import { EditOutlined } from '@ant-design/icons'
import { Button, Divider, Space, Tabs } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { apiGetOutletById } from '../../api'
import { OUTLET, UPDATE } from '../../assets/constants/route_path'
import ButtonBack from '../../components/button/ButtonBack'
import StatusTag from '../../components/outlet/StatusTag'
import { useLoading } from '../../context/LoadingContext'
import { IOutlet } from '../../models/outlet.modal'
import TabActivationHistory from './TabActivationHistory'
import TabActivity from './TabActivity'
import TabInfo from './TabInfo'
import TabInventory from './TabInventory'
import TabPricing from './TabPricing'

export default function OutletDetail() {
    const [searchParams] = useSearchParams()
    const id = searchParams.get('id') || ''
    const navigate = useNavigate()
    const { setIsLoading } = useLoading()
    const [outlet, setOutlet] = useState<IOutlet | null>(null)

    const fetchOutlet = useCallback(async () => {
        if (!id) return
        try {
            setIsLoading(true)
            const resp: any = await apiGetOutletById(id)
            if (resp?.data == null) {
                setOutlet(null)
                return
            }
            setOutlet(resp.data as IOutlet)
        } catch (error) {
            console.log(error)
            setOutlet(null)
        } finally {
            setIsLoading(false)
        }
    }, [id, setIsLoading])

    useEffect(() => {
        fetchOutlet()
    }, [fetchOutlet])

    if (!id) {
        return (
            <div>
                <ButtonBack to={OUTLET} />
                <p>Thiếu tham số <code>id</code>.</p>
            </div>
        )
    }

    return (
        <div>
            <ButtonBack to={OUTLET} />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                <h1>Đại lý: {outlet?.name ?? '—'} <StatusTag status={outlet?.status} /></h1>
                <Space>
                    <Button
                        type='primary'
                        icon={<EditOutlined />}
                        disabled={!outlet}
                        onClick={() => outlet && navigate(OUTLET + UPDATE, { state: outlet })}
                    >
                        Cập nhật
                    </Button>
                </Space>
            </div>
            <Divider />
            <Tabs
                size='middle'
                items={[
                    {
                        key: 'info',
                        label: 'Thông tin',
                        children: <TabInfo outlet={outlet} />,
                    },
                    {
                        key: 'activity',
                        label: 'Lịch sử tương tác',
                        children: <TabActivity outletId={id} />,
                    },
                    {
                        key: 'pricing',
                        label: 'Thỏa thuận giá',
                        children: <TabPricing outletId={id} cpCode={outlet?.cpCode || ''} />,
                    },
                    {
                        key: 'inventory',
                        label: 'Kho SIM đã giao',
                        children: <TabInventory outletId={id} outletName={outlet?.name} cpCode={outlet?.cpCode || ''} />,
                    },
                    {
                        key: 'activation',
                        label: 'Lịch sử đấu nối',
                        children: <TabActivationHistory outletId={id} />,
                    },
                ]}
            />
        </div>
    )
}
